import React from 'react';
import { connect } from 'react-redux'
import PanelSeleccion from './PanelSeleccion';

//Importación de actions.
import {
    resetState,
    getScreenData,
    redirectVistaCliente,
    getCuentaData,
    getEmpresaData,
    getSaldosResumenesData,
    getIngresoAjustesData,
    getIngresoCobranzasData,
    filtroRubro,
    changeRubro,
    selectCombo,
    changeInput,
    guardarNovedad,
    mostrarComponente,
    changeCheck,
    cancelar,
    changeDate,
    changeDataError,
    estadoEdicion,
    guardarCampo,
    guardarNovedades,
    changeEditView,
    changeText,
    guardarNovedadBloqueo,
    realizarBajaCuentaTarjeta,
    /*Tarjetas*/
    bloquearTarjeta,
    getTarjetaData,
    /*Fin Tarjetas*/
    mostrarModal,
    actualizarNovedadEstado,
    actualizarNovedadEstados,
    getDiasVigencia,
    openModalBajaCuenta,
    closeModalBajaCuenta,
    valorTextArea,
    valorSelect,
    changeCheckSolicitarCaidaCuotas
} from '../actions/PanelSeleccionActions';

const mapStateToProps = (state) => {
    let result = {
        data: state.panelSeleccion.data,
        ingresoAjustes: state.ingresoAjustes,
        ingresoCobranzas: state.ingresoCobranzas,
        vistaCliente: state.vistaCliente.data,
        executionContext: state.sesion.executionContext
    }

    result.saldosResumenes = ((state.saldosResumenes) ? state.saldosResumenes.data : undefined);

    if (!state.panelSeleccion.data) {
        delete result.data
    }

    return result;
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetState: () => {
            dispatch(resetState());
        },
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        guardarCampo: (valor, campo, ...params) => {
            dispatch(guardarCampo(valor, campo, ...params));
        },
        redirectVistaCliente: () => {
            dispatch(redirectVistaCliente());
        },
        getEmpresaData: (id) => {
            dispatch(getEmpresaData(id));
        },
        getCuentaData: (id) => {
            dispatch(getCuentaData(id));
        },
        realizarBajaCuentaTarjeta: () => {
            dispatch(realizarBajaCuentaTarjeta());
        },
        getSaldosResumenesData: (id) => {
            dispatch(getSaldosResumenesData(id));
        },
        getIngresoAjustesData: (id) => {
            dispatch(getIngresoAjustesData(id));
        },
        getIngresoCobranzasData: (id) => {
            dispatch(getIngresoCobranzasData(id));
        },
        filtroRubro: (typeInput, isCheck) => {
            dispatch(filtroRubro(typeInput, isCheck));
        },
        changeRubro: (valueBuscador, select) => {
            dispatch(changeRubro(valueBuscador, select));
        },
        selectCombo: (entidad, action, id, ...params) => {
            dispatch(selectCombo(entidad, action, id, ...params))
        },
        changeInput: (entidad, action, value, ...params) => {
            dispatch(changeInput(entidad, action, value, ...params))
        },
        guardarNovedad: (novedad, form, ...params) => {
            dispatch(guardarNovedad(novedad, form, ...params))
        },
        mostrarComponente: (action, value, ...params) => {
            dispatch(mostrarComponente(action, value, ...params))
        },
        changeCheck: (entidad, action, value, ...params) => {
            dispatch(changeCheck(entidad, action, value, ...params))
        },
        changeDate: (entidad, action, value) => {
            dispatch(changeDate(entidad, action, value))
        },
        changeDataError: () => {
            dispatch(changeDataError());
        },
        cancelar: () => {
            dispatch(cancelar())
        },
        estadoEdicion: (value, componente) => {
            dispatch(estadoEdicion(value, componente))
        },
        guardarNovedades: (novedad) => {
            dispatch(guardarNovedades(novedad))
        },
        changeEditView: (estado) => {
            dispatch(changeEditView(estado))
        },
        changeText: (estado) => {
            dispatch(changeText(estado))
        },
        /*Tarjetas*/
        bloquearTarjeta: (value) => {
            dispatch(bloquearTarjeta(value))
        },
        guardarNovedadBloqueo: (value, componenteSeleccionado) => {
            dispatch(guardarNovedadBloqueo(value, componenteSeleccionado))
        },
        getTarjetaData: (cuentaTarjetaId) => {
            dispatch(getTarjetaData(cuentaTarjetaId));
        },
        /*Fin Tarjetas*/
        mostrarModal: (mostrar, tituloCampo, entidadTipoId, novedadCampoCodigo, entidadId) => {
            dispatch(mostrarModal(mostrar, tituloCampo, entidadTipoId, novedadCampoCodigo, entidadId));
        },
        actualizarNovedadEstado: (novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId) => {
            dispatch(actualizarNovedadEstado(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId));
        },
        actualizarNovedadEstados: (novedad, estadoId, novedadTipoId, entidadId) => {
            dispatch(actualizarNovedadEstados(novedad, estadoId, novedadTipoId, entidadId));
        },
        getDiasVigencia: () => {
            dispatch(getDiasVigencia());
        },
        openModalBajaCuenta: () => {
            dispatch(openModalBajaCuenta());
        },
        closeModalBajaCuenta: () => {
            dispatch(closeModalBajaCuenta());
        },
        valorTextArea: (txtArea) => {
            dispatch(valorTextArea(txtArea));
        },
        valorSelect: (id) => {
            dispatch(valorSelect(id));
        },
        changeCheckSolicitarCaidaCuotas: () => {
            dispatch(changeCheckSolicitarCaidaCuotas());
        }
    }
}

//Connect entre el componente y las props y actions.
const PanelSeleccionContainer = connect(mapStateToProps, mapDispatchToProps)(PanelSeleccion);

export default PanelSeleccionContainer;